import { defineCatalogue } from '../../i18n';

export const collectionCatalogue = defineCatalogue(
  {
    'nav.label': 'Coleta',
    title: 'Amostragem de métricas',
    'enabled.name': 'Amostrar métricas completas',
    'enabled.hint':
      'Consulta visualizações, curtidas, comentários, compartilhamentos e salvamentos de cada publicação relacionada, dentro da janela de acompanhamento. Cada amostra é uma chamada paga ao provedor.',
    'minInterval.name': 'Intervalo mínimo',
    'minInterval.hint':
      'Nenhuma publicação é amostrada com mais frequência do que isto, qualquer que seja o ritmo do perfil.',
    'supporterFactor.name': 'Multiplicador para apoiadores',
    'supporterFactor.hint':
      'Contas que não são da própria campanha amostram o intervalo do perfil multiplicado por este valor.',
    'supporterCap.name': 'Teto para apoiadores',
    'supporterCap.hint':
      'O multiplicador nunca alonga o intervalo de um apoiador além disto, salvo quando o perfil já é mais lento.',
    'likersMax.name': 'Máximo de curtidores por publicação',
    'likersMax.hint':
      'Cada leitura paga devolve uma amostra dos curtidores (até cerca de 2.000) sem paginar; só os primeiros até este número entram na leitura dos comentários como sinal de "curtiu".',
    save: 'Salvar',
    saved: 'Salvo.',
    invalid: 'Informe números inteiros de 1 ou mais (máximo de curtidores: até 5.000).',
  },
  {
    'nav.label': 'Collection',
    title: 'Metric sampling',
    'enabled.name': 'Sample full metrics',
    'enabled.hint':
      'Reads views, likes, comments, shares and saves for every related post inside its tracking window. Each sample is a paid provider call.',
    'minInterval.name': 'Minimum interval',
    'minInterval.hint': 'No post is sampled more often than this, whatever the profile’s cadence.',
    'supporterFactor.name': 'Supporter multiplier',
    'supporterFactor.hint':
      'Accounts that are not the campaign’s own sample at the profile’s interval times this value.',
    'supporterCap.name': 'Supporter cap',
    'supporterCap.hint':
      'The multiplier never stretches a supporter’s interval past this, unless the profile is already slower.',
    'likersMax.name': 'Maximum likers per post',
    'likersMax.hint':
      'Each paid read returns a sample of likers (up to about 2,000) and never paginates; only the first this many are kept for the comment reading’s "liked" signal.',
    save: 'Save',
    saved: 'Saved.',
    invalid: 'Enter whole numbers of 1 or more (maximum likers: at most 5,000).',
  },
);

export const t = collectionCatalogue.t;
